import { createAction, createErrorAction } from '../../actions/actionCreator';
import { GetTaxesOptions, GetTaxesResponse } from '@card/commonlib';
import { ActionsType } from '@card/types';

export enum TaxesActionType {
  FetchStarted = 'taxes/fetchStarted',
  FetchSuccess = 'taxes/fetchSuccess',
  FetchError = 'taxes/fetchError',
  CreateReportStarted = 'taxes/createReportStarted',
  CreateReportError = 'taxes/createReportError'
}

export const TaxesActions = {
  fetchStarted: (params: GetTaxesOptions) => createAction(TaxesActionType.FetchStarted, params),
  fetchSuccess: (data: GetTaxesResponse) => createAction(TaxesActionType.FetchSuccess, data),
  fetchError: (error: Error) => createErrorAction(TaxesActionType.FetchError, error),
  createReportStarted: (params: GetTaxesOptions) =>
    createAction(TaxesActionType.CreateReportStarted, params),
  createReportError: (error: Error) => createErrorAction(TaxesActionType.CreateReportError, error)
};

export type TaxesAction = ActionsType<typeof TaxesActions>;
